import { useEffect, useRef } from 'react';

function useEffectSkipFirst(callback, dependencies) {
    const hasMounted = useRef(false);

    useEffect(() => {
        if (hasMounted.current) {
            callback();
        } else {
            hasMounted.current = true;
        }
    }, dependencies); //eslint-disable-line react-hooks/exhaustive-deps
}

export default useEffectSkipFirst;